const endPoints = {
  USER_LOGIN: '/auth/login',
  USER_REGISTER: '/auth/signup',
  FORGET_PASSWORD: '/auth/forgot/password',
  USER_OTP: '/auth/check/otp',
  RESET_PASSWORD: '/auth/reset/password',
  UPDATE_PASSWORD: '/auth/password',
  UPDATE_PROFILE: '/auth/profile',
  GET_PROFILE: '/auth/profile',
  PLAN_LISTING: '/plans',
  SUBSCRIBE_PLAN: '/subscription/create-session',
  SUBSCRIBE_FREE_PLAN: '/subscription/activate-free-subscription',
  COUNTRIES_LIST: '/countries',
  SUBSCRIBE_SUCCESS: '/subscription/subscribe',
  SUBSCRIBE_CANCEL: '/subscription/cancel',
  CONTACT_US: '/contact-us',
};

export default endPoints;
